<template lang="html">
  <form
    class="block-form auth-form app-width"
    @submit.prevent="handleFormPasswordReset"
  >
    <div class="form-content">
      <div class="form-row logo-row">
        <BaseLogo />
      </div>

      <div class="form-row inputs-with-hidden-labels">
        <label>
          <div class="label-text">{{ passwordLabel }}</div>
          <input
            v-model="password"
            v-focus
            name="password"
            type="password"
            autocomplete="new-password"
            :placeholder="passwordLabel"
            required
          />
        </label>

        <label>
          <div class="label-text">Confirm password</div>
          <input
            v-model="passwordConfirmation"
            name="password_confirm"
            type="password"
            autocomplete="new-password"
            placeholder="Confirm password"
            required
          />
        </label>
      </div>

      <BaseLoadingButton
        class="form-row"
        button-text="Save Password"
        :is-loading="isLoading"
      />

      <ErrorList :errors="serverErrors" />
    </div>
  </form>
</template>

<script>
import authenticationMixin from '@/mixins/authentication';

export default {
  name: 'PasswordReset',
  mixins: [authenticationMixin],

  props: {
    passwordLabel: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      firstRequest: true,
    };
  },

  methods: {
    setupHeaderContext() {
      this.$store.dispatch('setHeaderContext', {
        componentName: null,
      });
    },

    async handleFormPasswordReset() {
      // NOTE: If user is already logged in, log them out first. This
      // circumvents access token clashes and fringe cases where the user is
      // already logged in as someone else.
      if (this.$auth.check()) {
        await this.handleLogout({ redirect: null });
      }

      const options = {};

      // Manually transfer token data sent via the query string from the
      // password_edit API endpoint into the header. We only need to do this on
      // the first request because axios will automatically cycle in a new
      // access token on subsequent requests.
      if (this.firstRequest) {
        options.headers = {
          'access-token': this.$route.query['access-token'],
          client: this.$route.query.client,
          uid: this.$route.query.uid,
        };
      }

      const resp = await this.handleFormRequest(() =>
        this.axios.put(
          'auth/password',
          {
            password: this.password,
            password_confirmation: this.passwordConfirmation,
          },
          options
        )
      );

      if (resp.status >= 200 && resp.status < 300) {
        this.$toasted.show('Password set. Logging in…', {
          type: 'success',
        });

        this.email = this.$route.query.uid;
        this.handleFormLogin();
      } else {
        this.firstRequest = false;
      }
    },
  },
};
</script>
